import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Transactions.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from 'axios';
import {token, domain} from './../Security';
import {CreateTableForEmployeeSelect} from './../ManageTable';
import loadingSpinner from './../../assets/loading.gif';
import {useTable} from 'react-table';
import {globalTimeFormat} from './../Security';
// icons
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

function RelationshipDisclosureRequest({user, userAccess, isHideSideMenu}) {
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [employee, setEmployee] = useState( user.employeePersonalInformationFullName );
    const [employeeId, setEmployeeId] = useState( user.employeePersonalInformationId );

    const [email, setEmail] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [haveRelationship, setHaveRelationship] = useState(false);
    const [noOfRelatedPeople, setNoOfRelatedPeople] = useState(0)
    const [relationshipData, setRelationshipData] = useState([])

    const [showVieHistoryForm, setShowVieHistoryForm] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const resetVariables = () => {
        setEmail(null);
        setContactNo("");
        setNoOfRelatedPeople(0)
        setRelationshipData([])
        setHaveRelationship(false);
    }

    const handleRelationshipChange = (index, field, value) => {
        const updatedData = [...relationshipData];
        if (!updatedData[index]) updatedData[index] = {};
        updatedData[index][field] = value;
        setRelationshipData(updatedData);
    };

    const handleNoOfPeopleChange = (num) => {
        // 1. Update the count state
        setNoOfRelatedPeople(num);

        // 2. Synchronize the relationship data array
        setRelationshipData((prevData) => {
            // If the new number is smaller, slice(0, num) removes the extra items.
            // If the new number is larger, it returns the current array as is.
            return prevData.slice(0, num);
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!employee || 
            !email
            ) {
            alert("Required to fill up all data");
            return; // Exit early if fields are empty
        }

        for (let i = 0; i < noOfRelatedPeople; i++) {
            const person = relationshipData[i];

            // Check if the object exists and if all keys have values
            const isComplete = 
                person?.relationship && 
                person?.type && 
                person?.fullName?.trim() && 
                person?.company?.trim() && 
                person?.role?.trim();

            if (!isComplete) {
                return alert(`Please fill up all info for Relationship Disclosure #${i + 1}`);
            }
        }

        const data = {
            employeePersonalInformationId: employeeId ?? 0,
            email: email ?? "",
            contactNo: contactNo ?? "",
            haveRelationship: haveRelationship ?? false,
            noOfRelatedPeople: parseInt(noOfRelatedPeople),
            relationshipDisclosureDetail: relationshipData ?? [],
            createdBy: user?.id ?? null
        };

        try {
            setLoadingRequest(true);
            await axios.post(`${domain}/api/RelationshipDisclosure`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowRequestMessage(true);
            setIsSuccess(true);
            console.log('Data added successfully');

            // Reload table data and reset form fields
            resetVariables()
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error('Error:', error);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    const [errorState, setErrorState] = useState(false);
    const submit = (e) =>{
        if (!employee || 
            !email
            ) {
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const openViewHistoryForm = () => {
        setShowVieHistoryForm(true);
    }
    const closeViewHistoryForm = () => {
        setShowVieHistoryForm(false);
    }
    
    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                <div className="TransactionInfo Transaction-Form-Info">
                        <div className="transaction-header">
                            <div className='sub-title row'>
                                    <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Transactions >"} </span>
                                    <span style={{borderBottom:"1px solid black"}}>{"Relationship Disclosure"}</span>
                            </div>
                            <div className='row' style={{alignItems:"center", justifyContent:"space-between"}}>
                                <h3>Relationship Disclosure</h3>
                                <div className="transaction-form-upper row">
                                    {CreateButton("overtime-add-button", "viewHistory row", openViewHistoryForm, "VIEW HISTORY", RemoveRedEyeIcon)}
                                </div>
                            </div>
                        </div>
                        <div className="transaction-body">
                            <div className="bg-gray-50 p-4 border border-gray-200 rounded text-base text-gray-600 italic">
                                All information provided shall be treated with strict confidentiality and used solely for internal assessment and compliance purposes.
                            </div>
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Employee</h4></div>
                                        <div className="transaction-form-input">
                                            <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                                <input
                                                    readOnly
                                                    className='employeeInput-select'
                                                    placeholder="Employee"
                                                    value={employee ? (employee) : employee}
                                                />
                                                <button
                                                    className="select row"
                                                    onClick={() => setShowEmployeeForm(true)}
                                                    style={{
                                                        visibility:
                                                        userAccess.description === "Admin" ||
                                                        userAccess.description === "HR Head" ||
                                                        userAccess.description === "HR Assistant" ||
                                                        userAccess.description === "HR Assistant2" ||
                                                        userAccess.description === "HR Assistant3" ||
                                                        userAccess.description === "HR Manager"
                                                            ? "visible"
                                                            : "hidden",
                                                    }}
                                                    >
                                                    <SearchIcon />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !employee && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Email</h4></div>
                                        <div className="transaction-form-input">
                                            <input
                                                type='text'
                                                placeholder="yourname@email.com"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: !email && errorState ? "visible" : "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                            <div className="transaction-from-splitItem row">
                                <div className='column' style={{width:"100%"}}>
                                    <div className="transaction-form-item row">
                                        <div className="transaction-form-category"><h4>Contact No.</h4></div>
                                        <div className="transaction-form-input">
                                            <input
                                                type='text'
                                                placeholder="09xxxxxxxxx"
                                                value={contactNo}
                                                onChange={(e) => setContactNo(e.target.value)}
                                            />
                                        </div>
                                    </div>
                                    <span style={{
                                            marginTop:"-10px",
                                            display:"flex",
                                            justifyContent:"center",
                                            visibility: "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className='column' style={{width:"100%"}}>
                                </div>
                            </div>
                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                                <label className="block text-sm font-bold text-blue-900 mb-2">Do you have any personal or familial relationship with any of the following? <span className="text-red-500">*</span></label>
                                <div className="flex gap-6 mt-4">
                                    <label className="flex items-center cursor-pointer text-sm font-medium">
                                        <input type="radio" name="rel" checked={haveRelationship === true} onChange={() => setHaveRelationship(true)} className="w-4 h-4" />
                                        <span className="ml-2">Yes, I do</span>
                                    </label>
                                    <label className="flex items-center cursor-pointer text-sm font-medium">
                                        <input type="radio" name="rel" checked={haveRelationship === false} onChange={() => setHaveRelationship(false)} className="w-4 h-4" />
                                        <span className="ml-2">No, I don't</span>
                                    </label>
                                </div>
                            </div>

                            {haveRelationship &&
                            <>
                                <div className="flex flex-wrap justify-start gap-4 mt-10">
                                    {[1, 2, 3, 4, 5].map((num) => (
                                        <button
                                            key={num}
                                            type="button"
                                            // CHANGE THIS: Pass 'num', not 'e'
                                            onClick={() => handleNoOfPeopleChange(num)} 
                                            className={`cursor-pointer w-16 h-16 rounded-full border-2 font-bold text-xl transition-all 
                                                ${noOfRelatedPeople === num 
                                                    ? "bg-blue-600 border-blue-600 text-white scale-110 shadow-lg" 
                                                    : "bg-white border-gray-300 text-gray-600 hover:border-blue-400"
                                                }`}
                                        >
                                            {num}
                                        </button>
                                    ))}
                                </div>
                                
                                <div className="space-y-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
                                    {Array.from({ length: noOfRelatedPeople }).map((_, i) => (
                                        <div key={i} className="border-l-4 border-[#668fca] pl-6 py-2 space-y-6">
                                            <h4 className="text-blue-800 font-black uppercase tracking-widest text-sm">
                                                {i === 0 ? "1ST" : i === 1 ? "2ND" : i === 2 ? "3RD" : i === 3 ? "4TH" : "5TH"} — RELATIONSHIP DISCLOSURE DETAILS
                                            </h4>

                                            <div>
                                                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Relationship Disclosure Detail <span className="text-red-500">*</span></label>
                                                <RelationshipDisclosureSelect data={relationshipData[i]?.relationship} setData={(val) => handleRelationshipChange(i, 'relationship', val)}  isEditable={true}/>
                                            </div>

                                            <div>
                                                <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Type of Relationship <span className="text-red-500">*</span></label>
                                                <TypeOfRelationshipSelect data={relationshipData[i]?.type} setData={(val) => handleRelationshipChange(i, 'type', val)}  isEditable={true}/>
                                            </div>
                                            
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                                <div>
                                                    <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Full Name of Related Person <span className="text-red-500">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        placeholder="FULL NAME"
                                                        className="w-full p-2 outline-none border-none uppercase" style={{borderBottom: "1px solid gray"}}
                                                        onChange={(e) => handleRelationshipChange(i, 'fullName', e.target.value)}
                                                        value={relationshipData[i]?.fullName || ""}
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Name of Company <span className="text-red-500">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        placeholder="Sample: DLBI"
                                                        className="w-full p-2 outline-none border-none" style={{borderBottom: "1px solid gray"}}
                                                        onChange={(e) => handleRelationshipChange(i, 'company', e.target.value)}
                                                        value={relationshipData[i]?.company || ""}
                                                    />
                                                </div>
                                                <div>
                                                    <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Position / Role <span className="text-red-500">*</span></label>
                                                    <input 
                                                        type="text" 
                                                        className="w-full p-2 outline-none border-none" style={{borderBottom: "1px solid gray"}}
                                                        onChange={(e) => handleRelationshipChange(i, 'role', e.target.value)}
                                                        value={relationshipData[i]?.role || ""}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </>
                            }
                            <div className="transaction-form-footer">
                                {CreateButton("overtime-add-button", "submit", (e)=>submit(e), "SEND REQUEST", "")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ViewHistoryForm  isOpen={showVieHistoryForm} 
                    onClose={closeViewHistoryForm}
                    user={user}
            >
            </ViewHistoryForm>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeeId}
                    setEmployee={setEmployee}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest ? (
                <div
                    style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100vw",
                    height: "100vh",
                    zIndex: "2000",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    backgroundColor: "#ffffff59",
                    }}
                >
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}
function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function ViewHistoryForm({isOpen, 
    onClose,
    user
}){
    var header = [
        "Name",
        "Position",
        "Site",
        "Have Personal Rel. w/ Listed Above?",
        "No. Of Relationship Disclosure",
        "",
    ]
    var accessor = [
        "fullName",
        "positionDescription",
        "locationDescription",
        "haveRelationship",
        "noOfRelatedPeople",
        "manage"
    ]

    const [loading, setLoading] = useState(false);
    const [requests, setRequests] = useState(false);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/RelationshipDisclosure";

        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}/employee/${user.employeePersonalInformationId}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            setRequests(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [user]);

    useEffect(() => {
        if(isOpen){
            fetchData();
        }
    }, [fetchData, isOpen]);

    const handleClose = () => {
        onClose();
    };

    const fetchDataById = useCallback(async (_data) => {
        const apiUrl =  domain + "/api/RelationshipDisclosure";

        try {
            const response = await axios.get(`${apiUrl}/${_data.id}` , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return null
        }
    }, []);

    const [selectedData, setSelectedData] = useState(null)
    
    const [showViewForm, setShowViewForm] = useState(false);
    const openViewForm = () => {
        setShowViewForm(true);
    }
    const closeViewForm = () => {
        setShowViewForm(false);
        setSelectedData(null);
    }
    
    const viewHandleClick = async (_data) => {
        setLoading(true);

        const dataById = await fetchDataById(_data);

        const _uploadedFile = dataById.uploadedFile
            ? {
                base64: dataById.uploadedFile,
                contentType: DetectMimeTypeFromBase64(dataById.uploadedFile),
                fileName: `Uploaded_File.${DetectMimeTypeFromBase64(
                    dataById.uploadedFile
                ).split("/")[1]}`
            }
            : null;

        setSelectedData({
            ...dataById,
            uploadedFile: _uploadedFile
        });

        openViewForm();
        setLoading(false);
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Relationship Disclosure History</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body loan-history-table user-template-body">
                        <div className="users-table container" style={{overflow:"unset"}}>
                            <CreateTable
                                dataList={requests ? requests : []}
                                dataHeader={header}
                                dataAccessor={accessor}
                                viewHandleClick={viewHandleClick}
                            />
                            {requests.length > 0 ? (
                                <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"center", padding:"40px 40px 20px 40px"}}>
                    </div>
                </div>
            )}
            </div>

            <DisclosureViewModal
                isOpen={showViewForm}
                onClose={closeViewForm}
                selectedData={selectedData}
            />
        </>
    );
}

const DisclosureViewModal = ({
    isOpen,
    onClose,
    selectedData
}) => {
    if (!isOpen) return null;

    // Helper to display labels and values
    const DataField = ({ label, value }) => (
        <div className="py-2">
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
            <p className="text-sm font-medium text-gray-800 uppercase">{value || "—"}</p>
        </div>
    );

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 z-[10000]">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] flex flex-col rounded-lg shadow-2xl overflow-hidden border border-gray-200">
                
                {/* HEADER / BANNER */}
                <div className="bg-[#668fca] p-8 text-white shrink-0 relative">
                    <div className="absolute top-4 right-4">
                        <button onClick={onClose} className="cursor-pointer border-none bg-transparent text-white hover:text-gray-200 text-2xl font-bold leading-none">&times;</button>
                    </div>
                    <h2 className="text-2xl font-black uppercase tracking-tighter">Relationship Disclosure</h2>
                    <p className="text-blue-100 text-xs font-bold uppercase tracking-widest mt-1">Don Lee Builders Inc. — Compliance Document</p>
                </div>

                {/* DOCUMENT BODY */}
                <div className="p-10 overflow-y-auto flex-1 bg-white">
                    
                    {/* SECTION 1: DISCLOSER INFORMATION */}
                    <section className="mb-10">
                        <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-4">
                            I. Discloser Information
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                            <DataField label="Full Name" value={`${selectedData?.fullName ?? ""}`} />
                            <DataField label="Email Address" value={selectedData?.email ?? ""} />
                            <DataField label="Contact Number" value={selectedData?.contactNo ?? ""} />
                            <DataField label="Position" value={selectedData?.positionDescription ?? ""} />
                            <DataField label="Project / Site" value={selectedData?.locationDescription ?? ""} />
                        </div>
                    </section>

                    {/* SECTION 2: STATUS */}
                    <section className="mb-10">
                        <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-4">
                            II. Disclosure Status
                        </h3>
                        <div className={`inline-block px-4 py-2 rounded font-bold text-sm ${selectedData?.haveRelationship ? "bg-amber-50 text-amber-700 border border-amber-200" : "bg-green-50 text-green-700 border border-green-200"}`}>
                            {selectedData?.haveRelationship 
                                ? `YES — I have relationship(s) to disclose (${selectedData?.noOfRelatedPeople} person/s)` 
                                : "NO — I have no personal or familial relationships to disclose"
                            }
                        </div>
                    </section>

                    {/* SECTION 3: RELATED PEOPLE (Only if true) */}
                    {selectedData?.haveRelationship && selectedData?.relationshipDisclosureDetail && selectedData?.relationshipDisclosureDetail.length > 0 && (
                        <section className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                            <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-6">
                                III. Details of Related Persons
                            </h3>
                            <div className="space-y-8">
                                {selectedData?.relationshipDisclosureDetail.map((person, i) => (
                                    <div key={i} className="bg-gray-50 p-6 rounded-lg border border-gray-200 relative">
                                        <div className="absolute -top-3 left-4 bg-[#668fca] text-white px-3 py-1 text-[10px] font-black rounded shadow-sm">
                                            PERSON #{i + 1}
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
                                            <div className="md:col-span-2">
                                                <DataField label="Full Name of Related Person" value={person.fullName} />
                                            </div>
                                            <DataField label="Relationship Disclosure Detail" value={person.relationship} />
                                            <DataField label="Type of Relationship" value={person.type} />
                                            <DataField label="Name of Company" value={person.company} />
                                            <DataField label="Position / Role" value={person.role} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    )}

                    {/* FOOTER CERTIFICATION TEXT */}
                    <div className="mt-12 pt-8 border-t border-gray-100 text-[11px] text-gray-400 italic text-justify leading-relaxed">
                        This document serves as a formal declaration. The discloser has certified that all information provided is true, complete, and correct. This data is protected under the company's privacy policy and data protection regulations.
                    </div>
                </div>

                {/* MODAL FOOTER */}
                <div className="p-6 bg-gray-50 border-t border-gray-100 flex justify-end">
                    <button 
                        onClick={onClose}
                        className="cursor-pointer bg-gray-800 hover:bg-black text-white px-8 py-2 rounded text-xs font-black tracking-widest uppercase transition-all shadow-md"
                    >
                        Close Document
                    </button>
                </div>
            </div>
        </div>
    );
};

const DetectMimeTypeFromBase64 = (base64) => {
    if (!base64) return "application/octet-stream";

    const signatures = {
        "/9j/": "image/jpeg",
        "iVBORw0KGgo": "image/png",
        "R0lGOD": "image/gif",
        "JVBERi0": "application/pdf",
        "UEsDB": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // xlsx
        "0M8R4KGx": "application/vnd.ms-excel", // xls
        "UEsDBBQABgA": "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // docx
    };

    for (const signature in signatures) {
        if (base64.startsWith(signature)) {
            return signatures[signature];
        }
    }

    return "application/octet-stream"; // true fallback
};

export function CreateTable({ dataList = [], dataHeader = [], dataAccessor = [], editHandleClick, deleteHandleClick, viewHandleClick }) {
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const columns = React.useMemo(() =>
        dataHeader.map((header, index) => ({
            Header: header,
            accessor: dataAccessor[index]
        })),
        [dataHeader, dataAccessor]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({ columns, data: dataList });

    const indexOfFirstItem = (currentPage - 1) * itemsPerPage;
    const indexOfLastItem = Math.min(currentPage * itemsPerPage, rows.length);
    const currentItems = rows.slice(indexOfFirstItem, indexOfLastItem);

    const totalPages = Math.ceil(rows.length / itemsPerPage);
    const isLastPage = currentPage === totalPages;

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    return (
        <>
            <table {...getTableProps()}>
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps()}>
                                    {
                                    column.render("Header")
                                    }
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {dataList.length <= 0 &&
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: "center" }}>
                                No data to display
                            </td>
                        </tr>
                    }
                    {currentItems.map((row) => {
                        prepareRow(row)
                        return (
                            <tr key={row.original.id}
                            {...row.getRowProps()}
                            >
                                {row.cells.map((cell) => (
                                    SetInfo(cell.render("Cell").props.column.Header, 
                                            cell,
                                            editHandleClick,
                                            deleteHandleClick,
                                            viewHandleClick
                                        )
                                ))}
                            </tr>
                        )
                    })}
                </tbody>
            </table>
            {rows.length > itemsPerPage ? (
            <>
                <div className='table-page row' style={{alignItems:"center", justifyContent:"end", padding: "20px 0 0 0"}}>
                    <button className='prev row' onClick={() => paginate(1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        &lt;&lt;
                    </button>
                    <button className='prev row' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}
                            style={{ visibility: (currentPage === 1) ? 'hidden' : 'visible', marginRight:"5px", height:"26px" }}>
                        <NavigateBeforeIcon style={{marginRight:"5px"}}/> PREVIOUS
                    </button>
                    <button className='next row' onClick={() => paginate(currentPage + 1)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', marginRight:"5px", height:"26px" }}>
                        NEXT <NavigateNextIcon style={{ marginLeft: "5px" }} />
                    </button>
                    <button className='next row' onClick={() => paginate(totalPages)} disabled={indexOfLastItem >= rows.length}
                        style={{ visibility: (rows.length > itemsPerPage && !isLastPage) ? 'visible' : 'hidden', height:"26px"}}>
                        &gt;&gt;
                    </button>
                </div>
                {`${currentPage}/${totalPages}`}
            </>
            ) :
            <></>}
        </>
    )
}
function SetInfo(header, _cell, editHandleClick, deleteHandleClick, viewHandleClick) {
    const data = _cell.render("Cell").props.row.original;
    const value = _cell.render("Cell").props.value;

    if (header === "") {
        return(
            <td>
                <div className="row"  style={{alignItems:"center", justifyContent:"center"}}>
                    {editHandleClick &&
                    <Tooltip text="Update">
                        <div style={{padding:"0 5px"}} onClick={()=>editHandleClick(data)}><ModeEditIcon/></div>
                    </Tooltip>}
                    { deleteHandleClick ? 
                    <Tooltip text="Delete">
                        <div style={{padding:"0 5px"}} onClick={()=>deleteHandleClick(data)}><DeleteForeverIcon/></div>
                    </Tooltip>
                    :
                    <></>
                    }
                    { viewHandleClick && 
                    <Tooltip text="View">
                        <div style={{padding:"0 5px"}} onClick={()=>viewHandleClick(data)}><RemoveRedEyeIcon/></div>
                    </Tooltip>
                    }
                </div>
            </td>
        )
    }

    if(header === "Have Personal Rel. w/ Listed Above?"){
        const value = _cell.render("Cell").props.value;

        if(value){  
            return(
                <td>
                    YES
                </td>
            )
        }
        else{
            return(
                <td>
                    NO
                </td>
            )
        }
    }

    if (header === "Types of Complaint") {
        const value = _cell.render("Cell").props.value;

        if (!value || value.length === 0) {
            return <td>No type</td>;
        }

        return (
            <td>
                {value.map(item => item.type).join(", ")}
            </td>
        );
    }
    
    if(header === "Proof of Approval"
        || header === "GPS Cam"
        || header === "Medical Certificate"
    ) {
        return(
            <td>
                <Tooltip text="View">
                    <div style={{padding:"0 5px"}} onClick={()=>viewHandleClick(data, header)}><RemoveRedEyeIcon/></div>
                </Tooltip>
            </td>
        )
    }

    if(header === "Uploaded Image"){
        if(data.content){
            const imageSrc = 'data:image/jpeg;base64,' + data.content;

            return(
                <td>
                    <img className="" src={imageSrc} alt="" style={{width: "250px", height: "auto"}}/>
                </td>
            )
        }
        return(
            <td>
                <img className="" src="" alt=""/>
            </td>
        )
    }

    if(header === "Reference No."){
        const formattedNumber = value.toString().padStart(6, '0');

        if(data.requestTypeId === 1){
            return (
                <td>
                    LV-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 2){
            return (
                <td>
                    CS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 3){
            return (
                <td>
                    OT-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 4){
            return (
                <td>
                    CH-{formattedNumber}
                </td>
            );
        }  else if(data.requestTypeId === 5){
            return (
                <td>
                    OS-{formattedNumber}
                </td>
            );
        } else if(data.requestTypeId === 6){
            return (
                <td>
                    OB-{formattedNumber}
                </td>
            );
        } 
    }

    if(header === "Approved?"){
        return(
            <td>
                <input type="checkbox" 
                    id="overtime-allowance" 
                    className="checkbox"
                    name="" 
                    checked={data.isApproved}
                    disabled={true}
                />
            </td>
        )
    }

    if(header === "Has Allowance" || header === "Is Above 2 Hours"){
        return (
            <td>
                {value.toString()}
            </td>
        );
        
    }

    if(header === "Time From"
    || header === "Time To"
    || header === "Time In"
    || header === "Time Out"
    ){
        const time = _cell.render("Cell").props.value;
        if(!time) {
            return (
                <td>
                    null
                </td>
            );
        }

        let timeParts;
        let formattedTime;

        if (globalTimeFormat === "Standard Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            // Convert 24-hour format to 12-hour format and determine AM or PM
            const amPm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

            formattedTime = `${hours}:${minutes} ${amPm}`;
        } else if (globalTimeFormat === "Military Time"){
            const timeSplit = time.split('T');
            if (timeSplit.length > 1) {
                timeParts = timeSplit[1].substr(0, 5).split(':');
            } else {
                timeParts = [];
            }
            let hours = parseInt(timeParts[0], 10);
            const minutes = timeParts[1];

            formattedTime = `${hours}:${minutes}`;
        }

        return (
            <td>
                {formattedTime}
            </td>
        );
    }
    
    if(header === "Date"
    || header === "Date From"
    || header === "Date To"
    || header === "Date Processed"
    || header === "Request Date"
    || header === "Date Requested"
    ){
        const date = new Date(_cell.render("Cell").props.value);
        if(!date) {
            return (
                <td>
                    null
                </td>
            );
        }

        const mm = date.getMonth() + 1; // Adding 1 because getMonth returns 0-indexed months
        const dd = date.getDate();
        const yyyy = date.getFullYear();

        const formattedDateFrom = `${mm}/${dd}/${yyyy}`;
        
        return(
            <td>
                {formattedDateFrom}
            </td>
        )
    }

    //Double type data
    if(header === "Over Percentage"
    || header === "Deduction"
    || header === "Salary"
    || header === "Employee"
    || header === "Employer"
    || header === "Range From"
    || header === "Range To"
    || header === "Monthly Salary"
    || header === "SSS ER"
    || header === "SSS EE"
    || header === "SSS Total"
    || header === "ECER"
    || header === "Total Contribution ER"
    || header === "Total Contribution EE"
    || header === "Total Contribution Total"
    || header === "SE Total Contribution"
    || header === "Salary Range From"
    || header === "Salary Range To"
    || header === "Total Monthly Premium"
    || header === "Percentage"
    || header === "Amount"
    || header === "Total Loan"
    || header === "Total Balance"
    || header === "Default Deduction"
    || header === "Allowance"
    || header === "Daily Salary"
    || header === "Allowance"
    || header === "Total Basic"
    || header === "Rate"
    || header === "Hours OT Regular"
    || header === "Total OT Regular"
    || header === "Hours OT Exceeded"
    || header === "Total OT Exceeded"
    || header === "Hours OT Restday"
    || header === "Total OT Restday"
    || header === "Hours Holiday Special"
    || header === "Total Holiday Special"
    || header === "Hours Holiday Regular"
    || header === "Total Holiday Regular"
    || header === "Hours Restday Holiday Special"
    || header === "Total Restday Holiday Special"
    || header === "Hours Restday Holiday Regular"
    || header === "Total Restday Holiday Regular"
    || header === "Additions"
    || header === "SSS"
    || header === "Pagibig"
    || header === "Philhealth"
    || header === "SSS Loan"
    || header === "SSS Calamity Loan"
    || header === "Pagibig Loan"
    || header === "Pagibig Calamity Loan"
    || header === "Tax"
    || header === "Deductions"
    || header === "Adjustments"
    || header === "Total Net Pay"
    || header === "Days Absent"
    || header === "Absent/s"
    || header === "Days Leave"
    || header === "Leave/s"
    || header === "Hours Exceeded"
    || header === "Total Exceeded"
    || header === "Hours Undertime"
    || header === "Undertime"
    || header === "Hours Late"
    || header === "Late"
    || header === "Night Diff"
    || header === "OT Regular"
    || header === "OT Restday"
    || header === "Holiday Special"
    || header === "Holiday Regular"
    || header === "Restday Holiday Special"
    || header === "Restday Holiday Regular"
    || header === "Total Absents"
    || header === "Total Late"
    || header === "Total Undertime"
    || header === "Total Leaves"
    || header === "Total Night Diff"
    || header === "Total Exceed"
    || header === "Exceed"
    ){
        const value = _cell.render("Cell").props.value;

        // Check if value is a number
        const isNumber = typeof value === 'number';

        const numberWithCommasAndDecimal = (number) => {
            return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        };

        if(!isNumber){
            return (
                <td {..._cell.getCellProps()}> {
                    _cell.render("Cell")
                    }
                </td>
            )
        }

        const formattedNumber = numberWithCommasAndDecimal(value);

        return(
            <td>
                {formattedNumber}
            </td>
        )
    }

    return (
        <td {..._cell.getCellProps()}> {
            _cell.render("Cell")
            }
        </td>
    )
}
const Tooltip = ({ text, children }) => {
    const [show, setShow] = useState(false);

    const handleMouseEnter = () => {
        setShow(true);
    };

    const handleMouseLeave = () => {
        setShow(false);
    };

    return (
        <div style={{ position: 'relative', display: 'inline-block',zIndex:"1" }}>
            <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            {children}
            </div>
            {show && (
            <div
                style={{
                position: 'absolute',
                top: '50%',
                left: '-50%',
                transform: 'translateX(-50%)',
                backgroundColor: 'white',
                color: 'gray',
                padding: '5px',
                borderRadius: '5px',
                pointerEvents: "none",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"
                }}
            >
                {text}
            </div>
            )}
        </div>
    );
};

const TypeOfRelationshipSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setData(event.target.value);
    };

    useEffect(() => {
        setIsSelected(!!data && data !== 0);
    }, [data]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    <option value={`Romantic relationship with a fellow employee`} className='text-gray-700'>
                        {`Romantic relationship with a fellow employee`}
                    </option>
                    <option value={`Related by blood/marriage (up to 2nd degree) with a fellow employee`} className='text-gray-700'>
                        {`Related by blood/marriage (up to 2nd degree) with a fellow employee`}
                    </option>
                    <option value={`Romantic relationship with employee/representative of trade contractor or subcontractor`} className='text-gray-700'>
                        {`Romantic relationship with employee/representative of trade contractor or subcontractor`}
                    </option>
                    <option value={`Related by blood/marrigae (up to 2nd degree) with employee/representative of trade contractor or subcontractor`} className='text-gray-700'>
                        {`Related by blood/marrigae (up to 2nd degree) with employee/representative of trade contractor or subcontractor`}
                    </option>
                </select>
            </div>
        </div>
    );
};
const RelationshipDisclosureSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setData(event.target.value);
    };

    useEffect(() => {
        setIsSelected(!!data && data !== 0);
    }, [data]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    <option value={`Company employee`} className='text-gray-700'>
                        {`Company employee`}
                    </option>
                    <option value={`Security Officer`} className='text-gray-700'>
                        {`Security Officer`}
                    </option>
                    <option value={`Supplier (Employee/Owner)`} className='text-gray-700'>
                        {`Supplier (Employee/Owner)`}
                    </option>
                    <option value={`Trade Contractor (Employee/Owner)`} className='text-gray-700'>
                        {`Trade Contractor (Employee/Owner)`}
                    </option>
                    <option value={`Management (Employee)`} className='text-gray-700'>
                        {`Management (Employee)`}
                    </option>
                    <option value={`Owner-side representative (Employee)`} className='text-gray-700'>
                        {`Owner-side representative (Employee)`}
                    </option>
                </select>
            </div>
        </div>
    );
};


export default RelationshipDisclosureRequest
